import React from "react";
import classNames from "classnames/bind";
import { warrantTest } from "../../constant/warrantTest";
import {
  Container,
  Row,
  Col,
  Spinner,
  Badge,
  Modal,
  Button,
} from "react-bootstrap";
import { Table } from "../../components/DataTable";
import YouTube from "react-youtube";
import { taskListType, taskListType15 } from "../../api/newApi/getTaskList"; //任務30
import { Column } from "react-table";
import { Key } from "../../icons/";
import { youtubeLinkType } from "../../api/newApi/getTaskList";
import { GameIndexDataType } from "../../model/index";
import { schoolCampaignCodeType } from "../../api/newApi/getCampaignQuery";
import api from "../../api";
import { CampaignType } from "../../api/newApi/getCampaignQuery";
import style from "./index.module.css";
import WarrantVerifyModel from "../../components/WarrantVerifyModel";
import StudentIDVerifyModel from "../../components/StundentIDVerifyModel";
import Navigation from "../Navigation";
import { Page } from "../../model";
import { KeyObject } from "crypto";

const cx = classNames.bind(style);
//更新時間
console.log('01/05 09:50');
export interface GameIndex {
  cuid: string | null;
  campaignName: string | null;
  CampaignQueryLoading: boolean;
  refreshTime: string;
  CampaignQuery: CampaignType[];
  setUserTaskRefresh: () => void;
  getCampaignRetry: () => void;
  userTaskList: taskListType[]; //任務30
  userTaskList15: taskListType15[];
  schoolCampaignCode: schoolCampaignCodeType[];
  handleGameCampaign: (
    cuid: string,
    campaignName: string,
    code: string,
    userName: string,
    m_type: string,
  ) => void;
}

const NAME_LENGTH = 20;
const ID_LENGTH = 20;
const EMAIL_LENGTH = 50;

const GameIndex: React.FC<GameIndex> = ({
  campaignName,
  cuid,
  refreshTime,
  setUserTaskRefresh,
  handleGameCampaign,
  CampaignQuery,
  CampaignQueryLoading,
  getCampaignRetry,
  schoolCampaignCode,
}) => {
  const inputSchoolCodeRef = React.useRef<HTMLInputElement | null>(null);
  const [handleTaskNo, setHandleTaskNo] = React.useState<string | null>(null);
  const [youtubeLink, setYoutubeLink] = React.useState<youtubeLinkType | null>(null);
  const [toggle, setToggle] = React.useState<boolean>(false);
  const [youtubeAlreadyPlayed, setYoutubeAlreadyPlayed] = React.useState<boolean>(false);
  const [applySchoolCampaignModelShow, setApplySchoolCampaignModelShow] = React.useState<boolean>(false);
  const [schoolCampaignCodeCorrect, setSchoolCampaignCodeCorrect] = React.useState<boolean>(false);
  const [schoolCampaignProfessorName, setSchoolCampaignProfessorName] = React.useState<string>("");
  const [studentName, setStudentName] = React.useState<string>("");
  const [studentID, setStudentID] = React.useState<string>("");
  const [studentEmail, setStudentEmail] = React.useState<string>("");
  const [warrantTestShow, setWarrantTestShow] = React.useState<boolean>(false);
  const [warrantTestAnswerArray, setWarrantAnswerArray] = React.useState<number[]>(new Array(12).fill(0));
  const [warrantTestType, setWarrantTestType] = React.useState<"test" | "testFail" | "testPass">("test");
  const [finsishedTaskCount, setFinishedTaskCount] = React.useState<number>(0);
  const [modalMessage, setModalMessage] = React.useState<string>("");
  const [isWarrantModalOpen, setIsWarrantModalOpen] = React.useState<boolean>(false);
  const [showQueryResult, setShowQueryResult] = React.useState(false);
  const [isVerifyModalOpen, setIsVerifyModalOpen] = React.useState(false); //  學生身份驗證 id
  const [selectedCuId, setSelectedCuId] = React.useState<string | null>(null);
  const [userTaskList, setUserTaskList] = React.useState<taskListType[]>([]); // 任務30清單
  const [userTaskList15, setUserTaskList15] = React.useState<taskListType15[]>([]); // 任務15清單
  const [currentTaskIsTask15, setCurrentTaskIsTask15] = React.useState(false);
  const [isTaskPassed, setIsTaskPassed] = React.useState<{ [key: string]: boolean }>({
    m19: false,
    m20: false,
  });
  const [showConfirmButton, setShowConfirmButton] = React.useState(true); //任務m30 結果後的按鈕
  const [isTasksFetched, setIsTasksFetched] = React.useState(false);

  const handleTaskClick = (taskId: string, youtubeLink: youtubeLinkType | null, isTask15: boolean) => {
    setCurrentTaskIsTask15(isTask15);
    setHandleTaskNo(taskId);
    const taskType: "T15" | "T30" = isTask15 ? "T15" : "T30";
    if (isTask15) {
      setShowConfirmButton(true);
      if (taskId === "m30") {
        // 任務 m30 的邏輯保持不變  
        setWarrantTestType("test");
        setWarrantTestShow(true);
        return;
      }
      // 對於其他任務15，打開測試顯示（但不立即觸發 userArticleReadCheck）
      if (taskId !== "m01" && taskId !== "m02") {
        if (youtubeLink) {
          setYoutubeLink(youtubeLink);
          if (youtubeLink && !youtubeLink.youtubeChannel) {
            setTimeout(() => {
              setYoutubeAlreadyPlayed(true);
            }, 1000);
          }
          setWarrantTestShow(true);
          (window.parent as any).scrollTo({
            top: 250,
            behavior: "smooth",
          });
        }
      } else {
        console.log("這是任務 m01 或 m02");
      }
      return;
    }

    // 任務30的邏輯
    setIsTaskPassed((prev) => ({ ...prev, [taskId]: true }));
    setHandleTaskNo(taskId);
    if (taskId === "m19" || taskId === "m20") {
      setWarrantTestType("testPass");
      setYoutubeLink(youtubeLink);
      readArticleTask("T30", true); // 任務30完成
      if (youtubeLink && !youtubeLink.youtubeChannel) {
        setTimeout(() => {
          setYoutubeAlreadyPlayed(true);
        }, 1000);
      }
      api.userArticleReadCheck({ cu_id: cuid, Stage: taskId, complete: true, tasktype: taskType }).then((response) => {
        console.log("API response:", response);
        if (response.err === "0000") {
        }
      });
      setWarrantTestShow(true);
      (window.parent as any).scrollTo({
        top: 250,
        behavior: "smooth",
      });
      setTimeout(() => {
        const url = taskId === "m19" ? "https://twsa.warranttw.tw/articles/25" : "https://twsa.warranttw.tw/articles/117";
        const newWindow = window.open(url, "_blank");
        if (newWindow) {
          newWindow.focus();
        } else {
        }
      }, 0);
    }
  }
  // 如果網址是學校活動頁面，就顯示任務15的按鈕 反之任務30
  React.useEffect(() => {
    const fetchTasks = async () => {
      const isSchoolCampaign = (window.parent as any).location.href.includes("tradSchoolCampaign");
      if (isSchoolCampaign) {
        const response = await api.getTaskList15({ cu_id: cuid });
        if (response.err === "0000") {
          setUserTaskList15(response.user_task[0].taskList);
        }
      } else {
        const response = await api.getTaskList({ cu_id: cuid });
        if (response.err === "0000") {
          setUserTaskList(response.user_task[0].taskList);
        }
      }
      setIsTasksFetched(true);
    };

    if (CampaignQuery.length > 0 && !isTasksFetched) {
      fetchTasks();
    }
  }, [CampaignQuery, isTasksFetched]);

  const closeWarrantModal = () => {
    setIsWarrantModalOpen(false);
  };

  const numberFormatter = (value: string) =>
    (+value).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

  const resetStudentInfo = () => {
    setStudentName("");
    setStudentID("");
    setStudentEmail("");
    setSchoolCampaignProfessorName("");
    window.sessionStorage.removeItem("tempSchoolCampaignInfo");
  };

  const resetWarrantTestArray = () => {
    setWarrantAnswerArray(new Array(12).fill(0));
  };
  const handleMissionClose = (youtubeAlreadyPlayed: boolean) => {
    if (!youtubeAlreadyPlayed) {
      setWarrantTestShow(false);
      return;
    }
    readArticleTask("T15", true);
    setHandleTaskNo(null);
    setWarrantTestShow(false);
  };
  // 競賽列表 status=== true 才會渲染
  // tips 如果需要提前驗證例如 學生信箱驗證 無法查看
  const filteredCampaignQuery = React.useMemo(() => {
    return CampaignQuery.filter((campaign) => campaign.status === true);
  }, [CampaignQuery]);

  const taskFinishCount = () => {
    let count = 0;
    userTaskList.forEach((v) => {
      if (v.finishedTime) {
        count++;
      }
    });
    userTaskList15.forEach((v) => {
      if (v.finishedTime) {
        count++;
      }
    });
    setFinishedTaskCount(count);
  };

  React.useEffect(() => {
    setTimeout(() => {
      setToggle(!toggle);
    }, 30 * 1000);
  }, [toggle]);

  React.useEffect(() => {
    setUserTaskRefresh();
  }, [warrantTestShow, toggle]);

  React.useEffect(() => {
    (window.parent as any).resizeIframe();
  }, [CampaignQuery, refreshTime]);

  React.useEffect(() => {
    taskFinishCount();
  }, [CampaignQuery, userTaskList, userTaskList15]);

  React.useEffect(() => {
    if (modalMessage === "") {
      setModalMessage("請輸入活動邀請代碼");
    }
  }, [modalMessage]);
  //URL 是否有tradSchoolCampaign 如果沒有就是 模擬交易部分
  const isSchoolCampaign = (window.parent as any).location.href.includes("tradSchoolCampaign");

  // console.log('cuid', cuid)

  //學生身份驗證彈窗
  // 打開彈窗
  const openVerifyModal = (cu_id: string) => {
    setSelectedCuId(cu_id);
    setIsVerifyModalOpen(true);
  };

  // 關閉彈窗
  const closeVerifyModal = () => {
    setIsVerifyModalOpen(false);
  };

  const columns = React.useMemo<Column<GameIndexDataType>[]>(
    () => [
      {
        Header: "狀態",
        accessor: "status",
        sticky: "left",
        disableSortBy: true,
        Cell: (cellInfo: any) => (
          <div>
            {cellInfo.cell.row.original.status ? (
              "公開"
            ) : (
              <span className={cx("Icon_key")}>
                <Key />
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "時段",
        accessor: "s_timeToe_time",
        disableSortBy: true,
      },
      {
        Header: "活動名稱",
        accessor: "name",
        disableSortBy: true,
      },
      {
        Header: "活動起訖時間",
        accessor: "d_start_end",
        disableSortBy: true,
      },
      {
        Header: "盤別",
        accessor: "realtime",
        disableSortBy: true,
      },
      {
        Header: "起始資金",
        accessor: "init_cash",
        disableSortBy: true,
        Cell: (cellInfo: any) => (
          <>
            {
              <div
                onClick={() => {
                  console.log(cellInfo);
                }}>
                {numberFormatter(cellInfo.cell.row.original.init_cash.toString())}
              </div>
            }
          </>
        ),
      },
      {
        Header: "選擇活動",
        accessor: "action",
        disableSortBy: true,
        Cell: (cellInfo: any) => {
          const isDisabled = (() => {
            const now = new Date();
            const start = new Date(cellInfo.cell.row.original.d_start);
            const end = new Date(cellInfo.cell.row.original.d_end);

            // 將 d_end 設置為當天的最後一秒
            end.setHours(23, 59, 59, 999);

            // 判斷是否在開始時間之前或結束時間之後
            return now < start || now > end;
          })();
          return (
            <>
              {isSchoolCampaign ? (
                cellInfo.cell.row.original.joinSC ? (
                  <button
                    className={cx("startGame-btn")}
                    disabled={isDisabled}
                    onClick={() => {
                      api
                        .applyCampaign({
                          phone: cellInfo.cell.row.original.phone as string,
                          email: cellInfo.cell.row.original.email,
                          code: cellInfo.cell.row.original.action as string,
                          schoolCampaignInfos: {
                            schoolCode: inputSchoolCodeRef.current?.value || "",
                            studentName,
                            studentID,
                            studentEmail,
                          },
                        })
                        .then((e) => {
                          if (e.err === "0000") {
                            const cu_id = e.cu_id as string;
                            const { name, action, code, m_type } = cellInfo.cell.row.original;
                            const campaignName = `${name}`;
                            const user_name = e.user_name || ("" as string);
                            handleGameCampaign(
                              cu_id,
                              campaignName,
                              code,
                              user_name,
                              m_type
                            );
                          }
                        });
                    }}>
                    進入活動
                  </button>
                ) : (
                  <div
                    className={cx(
                      "d-flex",
                      "flex-nowrap",
                      "justify-content-around",
                      "align-items-center"
                    )}
                    style={{ minWidth: "250px" }}>
                    <input
                      style={{ textAlign: "start" }}
                      placeholder="輸入教授邀請碼"
                      className={cx("col-8")}
                      type="text"
                      ref={inputSchoolCodeRef}
                      id="applySchoolCampaignCode"
                      disabled={isDisabled}
                    />
                    <button
                      style={{ minWidth: "65px", fontSize: "12px" }}
                      className={cx("col-3", "btn", "enterCampaignButton")}
                      onClick={() => {
                        let code = inputSchoolCodeRef.current?.value || "";
                        if (code === "") {
                          setModalMessage("請輸入活動邀請代碼");
                          setApplySchoolCampaignModelShow(true);
                          return;
                        }
                        const target = schoolCampaignCode.find(
                          (item) => item.invcode === code
                        );
                        if (target) {
                          window.sessionStorage.setItem(
                            "tempSchoolCampaignInfo",
                            JSON.stringify(cellInfo.cell.row.original)
                          );
                          setSchoolCampaignProfessorName(target.profname);
                          setSchoolCampaignCodeCorrect(true);
                          setModalMessage("");
                        } else {
                          setSchoolCampaignCodeCorrect(false);
                          setModalMessage("請確認代碼是否輸入錯誤");
                        }
                        setApplySchoolCampaignModelShow(true);
                      }}
                      disabled={isDisabled}>
                      新增活動
                    </button>
                  </div>
                )
                // 學生身份驗證
              ) : cellInfo.cell.row.original.mailverifyflag && cellInfo.cell.row.original.mailverify !== "2" ? (
                <div key={cellInfo.cell.row.original.cu_id}>
                  <Button
                    className={cx("startGame-btn")}
                    style={{ backgroundColor: '#ED7D31', color: '#fff', height: '28px', padding: '0' }}
                    onClick={() => openVerifyModal(cellInfo.cell.row.original.cu_id)}
                  >
                    身份驗證
                  </Button>
                </div>
              ) : cellInfo.cell.row.original.status || cellInfo.cell.row.original.mailverify === "2" ? (
                <button
                  className={cx("startGame-btn")}
                  disabled={isDisabled}
                  onClick={() => {
                    api
                      .applyCampaign({
                        phone: cellInfo.cell.row.original.phone as string,
                        email: cellInfo.cell.row.original.email,
                        code: cellInfo.cell.row.original.action as string,
                        schoolCampaignInfos: {
                          schoolCode: inputSchoolCodeRef.current?.value || "",
                          studentName,
                          studentID,
                          studentEmail,
                        },
                      })
                      .then((e) => {
                        if (e.err === "0000") {
                          const cu_id = e.cu_id as string;
                          const { name, action, code, m_type } =
                            cellInfo.cell.row.original;
                          const campaignName = `${name}`;
                          const user_name = e.user_name || ("" as string);
                          handleGameCampaign(
                            cu_id,
                            campaignName,
                            code,
                            user_name,
                            m_type
                          );
                        }
                      });
                  }}>
                  進入活動
                </button>
              ) : (
                null
              )}
            </>
          );
        },
      }
    ],
    [schoolCampaignCode]
  );

  const readArticleTask = async (tasktype: "T15" | "T30", complete: boolean, warrantAnswerNumber?: number) => {
    console.log("userArticleReadCheck 參數:", {
      cu_id: cuid,
      Stage: handleTaskNo,
      complete,
      warrantAnswerNumber,
      tasktype,
    });

    if (!cuid || !handleTaskNo) return;

    const response = await api.userArticleReadCheck({
      cu_id: cuid,
      Stage: handleTaskNo,
      complete,
      warrantAnswerNumber,
      tasktype,
    });

    console.log("API:", response);
    if (response.err === "0000") {
      console.log("任務完成， userArticleReadCheck 成功");
    } else {
      console.error("任務失敗 userArticleReadCheck ", response.err);
    }
  };

  const showTaskIndex = (index: number) => {
    if (index < 10) {
      return "0" + index;
    } else {
      return `${index}`;
    }
  };

  React.useEffect(() => {
    if (!warrantTestShow) {
      setYoutubeLink(null);
      resetWarrantTestArray();
      setYoutubeAlreadyPlayed(false);
      window.sessionStorage.removeItem("task");
    }
  }, [warrantTestShow]);
  React.useEffect(() => {
    console.log("youtubeAlreadyPlayed", youtubeAlreadyPlayed);
  }, [youtubeAlreadyPlayed]);

  const warrantTestBody = () => {
    if (youtubeLink) {
      return (
        <>
          <div className={cx("contentWrapForArticle")}>
            <div className={cx("alertmodalContentColunn")}>
              {youtubeLink.youtubeChannel ? (
                <YouTube
                  videoId={youtubeLink.link}
                  className={cx("iframeContent")}
                  onEnd={() => {
                    setYoutubeAlreadyPlayed(true);
                  }}
                  opts={{ playerVars: { autoplay: 1 } }}
                />
              ) : (
                <iframe
                  className={cx("iframeArticle")}
                  src={youtubeLink.link}
                  allow=""
                  title={youtubeLink.title}
                  frameBorder="0"></iframe>
              )}
            </div>
          </div>
        </>
      );
    }
    switch (warrantTestType) {
      case "test":
        return (
          <>
            {warrantTest.map((item, index) => {
              return (
                <div className={cx("col-10", "mx-auto", "my-3", "text-start")}>
                  <div>{item.title}</div>
                  <div>{item.subtitle}</div>
                  <div>
                    {item.topics.map((v, i) => {
                      return (
                        <div
                          onClick={() => {
                            let answerArray = [...warrantTestAnswerArray];
                            answerArray[index] = v.topicIndex;
                            setWarrantAnswerArray(answerArray);
                            console.log(warrantTestAnswerArray);
                          }}
                          className={cx("d-flex", "align-items-center")}>
                          <div
                            className={cx("me-2")}
                            style={{
                              backgroundColor:
                                warrantTestAnswerArray[index] === i + 1 ? "#000" : "#fff",
                              height: "12px",
                              minWidth: "12px",
                              border: "1px solid #000",
                            }}>
                            {" "}
                          </div>
                          <span className={cx("me-2")}>{v.topicIndex}. </span>
                          <span>{v.content}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </>
        );
      case "testFail":
        return <div className={cx("text-center")}>有題目答錯囉，再考一次吧！</div>;
      case "testPass":
        return <div className={cx("text-center")}>任務完成</div>;
    }
  };

  const checkWarrantTest = () => {
    let ans = 0;
    warrantTest.forEach((v, i) => {
      if (v.answer === warrantTestAnswerArray[i]) ans++;
      if (ans === warrantTest.length) {
        v.answer = 12;
      }
    });

    const complete = ans === warrantTest.length;
    console.log("答對數量:", ans);
    console.log("總題數:", warrantTest.length);

    if (complete) {
      setWarrantTestType("testPass");
      resetWarrantTestArray();
      readArticleTask("T15", true, ans); // 任務完成 答對題目的數量


      if (handleTaskNo) {
        setIsTaskPassed(prevState => ({
          ...prevState,
          [handleTaskNo]: true
        }));
      }
      console.log("任務完成，userArticleReadCheck，tasktype 為 T15");
    } else {
      readArticleTask("T15", false, ans); // 任務失敗 答對題目的數量
      setWarrantTestType("testFail");
      resetWarrantTestArray();
    }
  };
  const reset30missions = async () => {
    if (!cuid) return;
    const headers = {
      "Content-Type": "application/json;charset=UTF-8",
    };
    fetch(`${process.env.REACT_APP_URL}api2/Warrant/ClearUserTask`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        cu_id: cuid,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.err === "0000") {
          setUserTaskRefresh();
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Container className={cx("container-left")} fluid>
        <div className={cx("text-color", "container-left")}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="currentColor"
            className="text-color bi bi-play"
            viewBox="0 0 16 16">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
          </svg>
          目前盤別：{campaignName ? campaignName : "尚未選擇活動"}
        </div>
        <div className={cx("text-color", "container-left", "wrap")}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="currentColor"
            className="text-color bi bi-play"
            viewBox="0 0 16 16">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
          </svg>
          我的活動
        </div>
        <Table
          columns={columns}
          data={filteredCampaignQuery}
          loading={CampaignQueryLoading}
        />
        {/* 判斷如果只要url不是校園競賽就不顯示 */}
        {(window.parent as any).location.href.includes("tradSchoolCampaign") ? (
          <>
            {/* 校園競賽顯示的任務15 */}
            <div style={{ width: "100%" }} className={cx("mt-4", "d-flex", "align-items-center", "justify-content-center")}>
              <hr className={cx("w-25", "me-sm-3", "d-none", "d-sm-block")} />
              <div className={cx("text-center", "w-75", "w-sm-50", "taskListTitleSchool")}></div>
              <hr className={cx("w-25", "ms-sm-3", "d-none", "d-sm-block")} />
            </div>

            <div className={cx("updateTime")}>更新時間：{refreshTime}</div> 
             <div className={cx("tip-wrapper")}>
              <div className={cx("tip-container")}>
                Tip <br />
                任務共四部分：
                <div className={cx("tip-detail")}>
                  <span>1.交易次數達10次&emsp;</span>
                  <span>2.下單日登入達5日以上&emsp;</span>
                  <span>3.觀看10支影片&emsp;</span>
                  <span>4.完成測驗 </span>
                </div>
              </div>
            </div> 

            {/* Img  */}
              <div className={cx("text-color", "container-left", "wrap")}>
               <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="text-color bi bi-play" viewBox="0 0 16 16">
                <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
              </svg> 
              目前已完成任務{""}
              <Badge
                className={cx("badge-box")}
                onClick={() => {
                  reset30missions();
                }}>
                {finsishedTaskCount}項
              </Badge>
            </div>  
            {/* 活動已結束 */}
            {!!(!userTaskList15 || userTaskList15.length <= 0) ? (
              <>
                <div className={cx("d-flex", "justify-center")}>
                 <Spinner animation="border" />
                 <h1>活動已結束</h1>
               </div> 
              </>
            ) : (
              <Row className={cx("mb-3")}>
                {userTaskList15.map((each, index) => (
                  <Col key={index} lg={4} sm={6} xs={12} className={cx("taskCol")}>
                    <div
                      className={cx("taskItem", each.finishedTime || isTaskPassed[each.taskId] ? "taskFinished" : "taskNotFinished")}
                      onClick={() => handleTaskClick(each.taskId, each.youtubelink || null, true)} // 設定 isTask15 為 true
                    >
                      <div style={{ padding: "10px", fontSize: "20px" }}>{showTaskIndex(index + 1)}</div>
                      <div
                        className={cx("flex-grow-1")}
                        style={
                          each.taskId !== "m01" && each.taskId !== "m02" && each.taskId !== "m15"
                            ? { textDecorationLine: "underline" }
                            : {}
                        }
                      >
                        {each.taskName}
                        {each.taskId === "m01" || each.taskId === "m02" ? (
                          <span className={cx("frequency-text")}>{'(' + each.frequency + ')'}</span>
                        ) : null}
                      </div>
                      <div style={{ padding: "10px" }}>
                        {(each.finishedTime || isTaskPassed[each.taskId]) ? (
                          <img height="35px" width="35px" alt="" src={require("../../static/image/taskChecked.png")} />
                        ) : (
                          <img height="35px" width="35px" alt="" src={require("../../static/image/taskNotChecked.png")} />
                        )}
                      </div>
                    </div>
                  </Col>
                ))}
               </Row>
            )}
          </>
        ) : (
          <>
            {/* 非校園競賽顯示的任務30 */}
              {/* <div style={{ width: "100%" }} className={cx("mt-4", "d-flex", "align-items-center", "justify-content-center")}>
              <hr className={cx("w-25", "me-sm-3", "d-none", "d-sm-block")} />
              <div className={cx("text-center", "w-75", "w-sm-50", "taskListTitle")}></div>
              <hr className={cx("w-25", "ms-sm-3", "d-none", "d-sm-block")} />
            </div>  
             <div className={cx("updateTime")}>更新時間：{refreshTime}</div>
            <div className={cx("text-color", " container-left", "wrap")}></div> 
             <div className={cx("text-color", "container-left", "wrap")}>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="text-color bi bi-play" viewBox="0 0 16 16">
                <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
              </svg>
              目前已完成任務{""}
              <Badge
                className={cx("badge-box")}
                onClick={() => {
                  reset30missions();
                }}>
                {finsishedTaskCount}項
              </Badge>
            </div>    */}

            {!!(!userTaskList || userTaskList.length <= 0) ? (
<>
              {/* <div className={cx("d-flex", "justify-center")}> */}
                  {/* <Spinner animation="border" />  */}
                {/* <h1>活動已結束</h1> */}
              {/* </div> */}
            </>
            ) : (
              <Row className={cx("mb-3")}>
                {userTaskList.map((each, index) => (
                  <Col key={index} lg={4} sm={6} xs={12} className={cx("taskCol")}>
                    <div
                      className={cx("taskItem", each.finishedTime || isTaskPassed[each.taskId] ? "taskFinished" : "taskNotFinished")}
                      onClick={() => {
                        if (each.taskId === "m19" || each.taskId === "m20") {
                          const isTask15 = (window.parent as any).location.href.includes("tradSchoolCampaign");
                          handleTaskClick(each.taskId, each.youtubelink || null, isTask15);
                        }
                      }}
                    >
                      <div style={{ padding: "10px", fontSize: "20px" }}>{showTaskIndex(index + 1)}</div>
                      <div className={cx("flex-grow-1")} style={each.taskId === "m19" || each.taskId === "m20" ? { textDecorationLine: "underline" } : {}}>
                        {each.taskName}
                      </div>
                      <div style={{ padding: "10px" }}>
                        {(each.finishedTime || isTaskPassed[each.taskId]) ? (
                          <img height="35px" width="35px" alt="" src={require("../../static/image/taskChecked.png")} />
                        ) : (
                          <img height="35px" width="35px" alt="" src={require("../../static/image/taskNotChecked.png")} />
                        )}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            )}
          </>
        )}
        {/* 底下tip */}
        <div className={cx("text-secondary", "small")} style={{ marginBottom: "0" }}>
          {" "}
          Tip:
        </div>
        <div>◎ 即時體驗</div>
        <ul className={cx("text-secondary", "small")} style={{ marginBottom: "0" }}>
          說明：模擬交易平台依據交易日當日實盤即時資料進行撮合
        </ul>
        <ul className={cx("text-secondary", "small")}>
          <li style={{ listStyleType: "upper-alpha" }}>
            交易時間 : 星期一至星期五（及證交所公告之補行交易日），撮合時間為9:00-13:30，委託時間8:30-13:30。
          </li>
          <li style={{ listStyleType: "upper-alpha" }}>
            {" "}
            使用者可進行模擬交易下單操作。
          </li>
          <li style={{ listStyleType: "upper-alpha" }}>起始資金：20萬元模擬金。</li>
          <li style={{ listStyleType: "upper-alpha" }}>入金：每日最多可入金一次，一次20萬元。</li>
          <li style={{ listStyleType: "upper-alpha" }}>重置帳戶：清除交易紀錄，並恢復預設初始資金。</li>
        </ul>
        <div>◎ 午間回播體驗</div>
        <ul className={cx("text-secondary", "small")} style={{ marginBottom: "0" }}>
          說明：模擬交易平台依據當日實盤回播資料進行撮合
        </ul>
        <ul className={cx("text-secondary", "small")}>
          <li style={{ listStyleType: "upper-alpha" }}>
            交易時間：星期一至星期五（及證交所公告之補行交易日），撮合時間為14:00-18:30，委託時間13:30-18:30。{" "}
          </li>
          <li style={{ listStyleType: "upper-alpha" }}>使用者可進行模擬交易下單操作。</li>
          <li style={{ listStyleType: "upper-alpha" }}>起始資金：20萬元模擬金。</li>
          <li style={{ listStyleType: "upper-alpha" }}>入金：每日最多可入金一次，一次20萬元。</li>
          <li style={{ listStyleType: "upper-alpha" }}>重置帳戶：清除交易紀錄，並恢復預設初始資金。</li>
        </ul>
        <div>◎ 晚間回播體驗</div>
        <ul className={cx("text-secondary", "small")} style={{ marginBottom: "0" }}>
          說明：模擬交易平台依據當日實盤回播資料進行撮合
        </ul>
        <ul className={cx("text-secondary", "small")}>
          <li style={{ listStyleType: "upper-alpha" }}>
            交易時間：星期一至星期五（及證交所公告之補行交易日），撮合時間為18:30-23:00，委託時間18:00-23:00。{" "}
          </li>
          <li style={{ listStyleType: "upper-alpha" }}>使用者可進行模擬交易下單操作。</li>
          <li style={{ listStyleType: "upper-alpha" }}>起始資金：20萬元模擬金。</li>
          <li style={{ listStyleType: "upper-alpha" }}>入金：每日最多可入金一次，一次20萬元。</li>
          <li style={{ listStyleType: "upper-alpha" }}>重置帳戶：清除交易紀錄，並恢復預設初始資金。</li>
        </ul>
        <div style={{ fontWeight: "bold" }}>「即時體驗」&「午間回播體驗」& 「晚間回播體驗」 損益分開計算。</div>

        <WarrantVerifyModel
          isOpen={isWarrantModalOpen}
          handleClose={closeWarrantModal}
          showQueryResult={showQueryResult}
          setShowQueryResult={setShowQueryResult}
          cu_id={cuid || ""} />
      </Container>

      <Modal
        show={warrantTestShow}
        onHide={() => {
          setWarrantTestShow(false);
        }}
        size="lg"
        backdrop="static"
        keyboard={false}>
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "transparent",
            color: `${youtubeLink && youtubeLink?.youtubeChannel ? "#F00" : "transparent"}`,
          }}
          className="text-center">
          <span className="flex-grow-1">觀看完整影片，達成任務!</span>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "450px", overflowY: "auto" }}>{warrantTestBody()}</Modal.Body>
        <Modal.Footer>
          <Button
            className={cx("modal-rounded", "px-5", { "d-none": !showConfirmButton || (youtubeLink && !youtubeAlreadyPlayed) })}
            onClick={() => {
              if (youtubeLink && !youtubeAlreadyPlayed) {
                handleMissionClose(youtubeAlreadyPlayed);
                return;
              }
              if (handleTaskNo === "m30") {
                checkWarrantTest();
                setWarrantTestShow(true);
                setShowConfirmButton(false);
              } else {
                readArticleTask("T15", true);
                setWarrantTestShow(false);
                if (handleTaskNo && currentTaskIsTask15) {
                  setIsTaskPassed((prev) => ({ ...prev, [handleTaskNo]: true }));
                }
              }
            }}
          >
            確認
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={applySchoolCampaignModelShow}
        onHide={() => {
          setApplySchoolCampaignModelShow(false);
          resetStudentInfo();
        }}
        size="sm"
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton className={cx("campaignModalHeader")}>
          <span className={cx("flex-grow-1", "text-center")}>
            {schoolCampaignCodeCorrect ? `加入${schoolCampaignProfessorName}教授競賽` : ""}
          </span>
        </Modal.Header>
        <Modal.Body>
          {schoolCampaignCodeCorrect ? (
            <>
              <div>請輸入學生資料</div>
              <div className={cx("col-10", "mt-3", "mb-1", "mx-auto")}>
                <input className={cx("w-100", "inputStyle")} placeholder="姓名" value={studentName} onChange={(e) => setStudentName(e.target.value)} />
              </div>
              <div className={cx("col-10", "my-1", "mx-auto")}>
                <input className={cx("w-100", "inputStyle")} placeholder="學號" value={studentID} onChange={(e) => setStudentID(e.target.value)} />
              </div>
              <div className={cx("col-10", "my-1", "mx-auto")}>
                <input className={cx("w-100", "inputStyle")} placeholder="學校信箱" value={studentEmail} onChange={(e) => setStudentEmail(e.target.value)} />
              </div>
            </>
          ) : (
            <div className={cx("mt-3")}>{modalMessage}</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className={cx("modal-rounded", "px-5")}
            onClick={() => {
              if (schoolCampaignCodeCorrect) {
                if (
                  !studentName ||
                  !studentID ||
                  !studentEmail ||
                  studentName.length > NAME_LENGTH ||
                  studentID.length > ID_LENGTH ||
                  studentEmail.length > EMAIL_LENGTH
                )
                  return alert("請輸入完整學生資料");
                const targetCampaign = JSON.parse(
                  window.sessionStorage.getItem("tempSchoolCampaignInfo") ||
                  "{}"
                );
                api
                  .applyCampaign({
                    phone: targetCampaign.phone as string,
                    email: targetCampaign.email ,
                    code: targetCampaign.action as string,
                    schoolCampaignInfos: {
                      schoolCode: inputSchoolCodeRef.current?.value || "",
                      studentName,
                      studentID,
                      studentEmail,
                    },
                  })
                  .then((e) => {
                    if (e.err === "0000") {
                      const cu_id = e.cu_id as string;
                      const { name, action, code, m_type } = targetCampaign;
                      const campaignName = `${name}`;
                      const user_name = e.user_name || ("" as string);
                      handleGameCampaign(
                        cu_id,
                        campaignName,
                        code,
                        user_name,
                        m_type
                      );
                      getCampaignRetry();
                    }
                  });
              }
              setApplySchoolCampaignModelShow(false);
              resetStudentInfo();
            }}>
            確認
          </Button>
        </Modal.Footer>
      </Modal>
      <StudentIDVerifyModel
        isOpen={isVerifyModalOpen}
        handleClose={closeVerifyModal}
        cu_id={selectedCuId!}
      />
    </>

  );

};

export default GameIndex;
